/* OVESSI : Cookie banner premium rewrite
 * Replaces Shopify's default banner copy with OVESSI wording
 * Keeps Accept / Decline / Manage preferences buttons wired to Shopify's privacy API
 * Reveals banner only after rewrite completes to avoid FOUC
 * Localised : EN, DE, FR, ES — picks from <html lang>
 */
(function () {
  'use strict';

  // Detect locale from <html lang="...">
  var rawLang = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
  var locale = 'en';
  if (rawLang.indexOf('de') === 0) locale = 'de';
  else if (rawLang.indexOf('fr') === 0) locale = 'fr';
  else if (rawLang.indexOf('es') === 0) locale = 'es';

  var COPY_BY_LOCALE = {
    en: {
      title: 'Your privacy',
      body: 'We and our trusted partners use cookies to personalise your experience, show relevant content, and understand how our site is used. You can accept all, decline, or manage your choices.',
      policyLink: 'Learn more in our Privacy Policy',
      btnAccept: 'Accept all',
      btnDecline: 'Decline',
      btnManage: 'Manage preferences'
    },
    de: {
      title: 'Deine Privatsphäre',
      body: 'Wir und unsere vertrauten Partner verwenden Cookies, um dein Erlebnis zu personalisieren, relevante Inhalte zu zeigen und unsere Website besser zu verstehen. Du kannst alle annehmen, ablehnen oder deine Auswahl verwalten.',
      policyLink: 'Mehr in unserer Datenschutzerklärung',
      btnAccept: 'Alle annehmen',
      btnDecline: 'Ablehnen',
      btnManage: 'Einstellungen verwalten'
    },
    fr: {
      title: 'Votre confidentialité',
      body: 'Avec nos partenaires de confiance, nous utilisons des cookies pour personnaliser votre expérience, vous proposer des contenus pertinents et comprendre l\u2019usage de notre site. Vous pouvez tout accepter, refuser, ou gérer vos choix.',
      policyLink: 'En savoir plus dans notre Politique de confidentialité',
      btnAccept: 'Tout accepter',
      btnDecline: 'Refuser',
      btnManage: 'Gérer mes préférences'
    },
    es: {
      title: 'Tu privacidad',
      body: 'Junto a nuestros socios de confianza usamos cookies para personalizar tu experiencia, mostrarte contenido relevante y entender cómo se usa nuestro sitio. Puedes aceptarlas todas, rechazarlas o gestionar tus elecciones.',
      policyLink: 'Más información en nuestra Política de privacidad',
      btnAccept: 'Aceptar todo',
      btnDecline: 'Rechazar',
      btnManage: 'Gestionar preferencias'
    }
  };

  var COPY = COPY_BY_LOCALE[locale] || COPY_BY_LOCALE.en;

  // Hide banner the moment any part of it renders, until we've rewritten it
  var hideStyle = document.createElement('style');
  hideStyle.id = 'luv-cookie-hide';
  hideStyle.textContent = [
    '#shopify-pc__banner:not([data-luv-rewritten]) {',
    '  opacity: 0 !important;',
    '  visibility: hidden !important;',
    '  transition: none !important;',
    '}',
    /* Premium restyle once rewritten */
    '#shopify-pc__banner[data-luv-rewritten] {',
    '  font-family: "DM Sans", system-ui, sans-serif !important;',
    '  background: #F7F2EA !important;',
    '  color: #14110F !important;',
    '  border: none !important;',
    '  box-shadow: 0 -8px 32px rgba(20,17,15,0.08) !important;',
    '}',
    '#shopify-pc__banner[data-luv-rewritten] .shopify-pc__banner__body-title,',
    '#shopify-pc__banner[data-luv-rewritten] h2 {',
    '  font-family: "Instrument Serif", Georgia, serif !important;',
    '  font-weight: 400 !important;',
    '  font-size: 22px !important;',
    '  letter-spacing: -0.005em !important;',
    '  color: #14110F !important;',
    '  margin-bottom: 8px !important;',
    '}',
    '#shopify-pc__banner[data-luv-rewritten] .shopify-pc__banner__body {',
    '  font-size: 14px !important;',
    '  line-height: 1.65 !important;',
    '  color: rgba(20,17,15,0.74) !important;',
    '}',
    '#shopify-pc__banner[data-luv-rewritten] a.shopify-pc__banner__body-policy-link {',
    '  color: #C9826B !important;',
    '  text-decoration: underline !important;',
    '  text-underline-offset: 3px !important;',
    '}',
    '#shopify-pc__banner[data-luv-rewritten] .shopify-pc__banner__btn-accept {',
    '  background: #2A1620 !important;',
    '  color: #F7F2EA !important;',
    '  border: 1px solid #2A1620 !important;',
    '  font-family: "DM Sans", sans-serif !important;',
    '  font-size: 12px !important;',
    '  letter-spacing: 0.18em !important;',
    '  text-transform: uppercase !important;',
    '  padding: 12px 24px !important;',
    '  border-radius: 0 !important;',
    '  font-weight: 500 !important;',
    '}',
    '#shopify-pc__banner[data-luv-rewritten] .shopify-pc__banner__btn-decline,',
    '#shopify-pc__banner[data-luv-rewritten] .shopify-pc__banner__btn-manage-prefs {',
    '  background: transparent !important;',
    '  color: #14110F !important;',
    '  border: 1px solid rgba(20,17,15,0.3) !important;',
    '  font-family: "DM Sans", sans-serif !important;',
    '  font-size: 12px !important;',
    '  letter-spacing: 0.18em !important;',
    '  text-transform: uppercase !important;',
    '  padding: 12px 24px !important;',
    '  border-radius: 0 !important;',
    '  font-weight: 500 !important;',
    '}',
    '#shopify-pc__banner[data-luv-rewritten] .shopify-pc__banner__btn-accept:hover {',
    '  background: #C9826B !important;',
    '  border-color: #C9826B !important;',
    '}',
    '#shopify-pc__banner[data-luv-rewritten] .shopify-pc__banner__btn-decline:hover,',
    '#shopify-pc__banner[data-luv-rewritten] .shopify-pc__banner__btn-manage-prefs:hover {',
    '  background: #14110F !important;',
    '  color: #F7F2EA !important;',
    '  border-color: #14110F !important;',
    '}'
  ].join('\n');
  (document.head || document.documentElement).appendChild(hideStyle);

  function rewriteBanner(banner) {
    if (!banner || banner.getAttribute('data-luv-rewritten')) return;

    try {
      // 1. Title
      var title = banner.querySelector('.shopify-pc__banner__body-title, h2');
      if (title) title.textContent = COPY.title;

      // 2. Body text (replace the text content but preserve the policy link)
      var body = banner.querySelector('.shopify-pc__banner__body');
      if (body) {
        // Remember the existing policy link href if present
        var existingLink = body.querySelector('a.shopify-pc__banner__body-policy-link, a[href*="privacy"]');
        var policyHref = existingLink ? existingLink.getAttribute('href') : '/policies/privacy-policy';

        // Rebuild body content
        body.innerHTML = '';

        // Re-add title element (since we cleared body) if it was inside body
        if (title && !banner.contains(title)) {
          var newTitle = document.createElement('h2');
          newTitle.className = 'shopify-pc__banner__body-title';
          newTitle.textContent = COPY.title;
          body.appendChild(newTitle);
        }

        var p = document.createElement('p');
        p.textContent = COPY.body + ' ';
        body.appendChild(p);

        var linkWrap = document.createElement('p');
        var a = document.createElement('a');
        a.className = 'shopify-pc__banner__body-policy-link';
        a.href = policyHref;
        a.textContent = COPY.policyLink;
        a.target = '_self';
        linkWrap.appendChild(a);
        body.appendChild(linkWrap);
      }

      // 3. Buttons : ensure all 3 exist with new labels
      var btnAccept = banner.querySelector('.shopify-pc__banner__btn-accept');
      if (btnAccept) btnAccept.textContent = COPY.btnAccept;

      var btnDecline = banner.querySelector('.shopify-pc__banner__btn-decline');
      if (btnDecline) {
        btnDecline.textContent = COPY.btnDecline;
        btnDecline.style.display = '';
      } else {
        // If Shopify didn't render a Decline button, inject one wired to the privacy API
        var btns = banner.querySelector('.shopify-pc__banner__btns, .shopify-pc__banner__btns-granular');
        if (btns) {
          var declineBtn = document.createElement('button');
          declineBtn.type = 'button';
          declineBtn.className = 'shopify-pc__banner__btn-decline';
          declineBtn.textContent = COPY.btnDecline;
          declineBtn.addEventListener('click', function () {
            try {
              if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
                window.Shopify.customerPrivacy.setTrackingConsent(
                  { analytics: false, marketing: false, preferences: false, sale_of_data: false },
                  function () { banner.style.display = 'none'; }
                );
              } else {
                banner.style.display = 'none';
              }
            } catch (e) { banner.style.display = 'none'; }
          });
          // Insert Decline between Accept and Manage if both present, else just append
          var btnManage = btns.querySelector('.shopify-pc__banner__btn-manage-prefs');
          if (btnManage) {
            btns.insertBefore(declineBtn, btnManage);
          } else {
            btns.appendChild(declineBtn);
          }
        }
      }

      var btnManage = banner.querySelector('.shopify-pc__banner__btn-manage-prefs');
      if (btnManage) btnManage.textContent = COPY.btnManage;

      // 4. Mark as rewritten so CSS reveals it
      banner.setAttribute('data-luv-rewritten', '1');
    } catch (err) {
      // Fail-safe : reveal the original banner if our rewrite throws, so consent capture still works
      banner.setAttribute('data-luv-rewritten', 'error');
      if (window.console && console.warn) console.warn('Luv banner rewrite failed:', err);
    }
  }

  function tryFindAndRewrite() {
    var banner = document.getElementById('shopify-pc__banner');
    if (banner) {
      rewriteBanner(banner);
      return true;
    }
    return false;
  }

  // Observe the entire body for the banner injection
  function startObserver() {
    if (tryFindAndRewrite()) return;
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1) {
            if (n.id === 'shopify-pc__banner') {
              rewriteBanner(n);
              return;
            }
            if (n.querySelector) {
              var b = n.querySelector('#shopify-pc__banner');
              if (b) {
                rewriteBanner(b);
                return;
              }
            }
          }
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });

    // Safety timeout : after 8s, reveal whatever banner state exists so consent still works
    setTimeout(function () {
      var banner = document.getElementById('shopify-pc__banner');
      if (banner && !banner.getAttribute('data-luv-rewritten')) {
        banner.setAttribute('data-luv-rewritten', 'timeout');
      }
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
